declare global {
  interface Window {
    posthog?: {
      capture?: (event: string, properties?: Record<string, unknown>) => void;
      identify?: (distinctId: string, properties?: Record<string, unknown>) => void;
      register?: (properties: Record<string, unknown>) => void;
      unregister?: (property: string) => void;
      people?: {
        set?: (properties: Record<string, unknown>) => void;
        set_once?: (properties: Record<string, unknown>) => void;
      };
    };
    SERVER_URL?: string;
  }
}

function posthogEventName(base: string): string {
  return window.SERVER_URL === 'https://live.televeda.com' ? base : `${base}_staging`;
}

function canCapture(): boolean {
  if (window.SERVER_URL === 'http://localhost:3000') return false;
  return typeof window.posthog?.capture === 'function';
}

export function trackUserRegistered(email: string): void {
  try {
    if (!canCapture()) return;
    const registeredAt = new Date().toISOString();
    const posthog = window.posthog!;

    if (typeof posthog.identify === 'function') {
      posthog.identify(email);
    }
    posthog.people?.set_once?.({
      registered_at: registeredAt,
    });
    posthog.people?.set?.({
      email,
    });

    posthog.capture?.(posthogEventName('user_registered'), {
      timestamp: registeredAt,
      email,
      page: typeof window !== 'undefined' ? window.location.pathname : null,
    });
  } catch {
  }
}
